/*
 * @Author: 李旭
 * @Date: 2021-12-22 11:44:47
 * @LastEditTime: 2024-11-12 21:36:06
 * @LastEditors: lixu
 * @Description:
 * @FilePath: \ems-web-ant5.0\src\utils\enumMenu.js
 *
 */
import React from 'react';
import * as AntIcons from '@ant-design/icons';

const pathIconDictionary = {
  '/home': 'HomeOutlined',
  '/data': 'DatabaseOutlined',
  '/data/collect': 'CloudUploadOutlined',
  '/data/collect/upload': 'UploadOutlined',
  '/data/collect/import': 'ImportOutlined',
  '/data/collect/thirdImport': 'ApiOutlined',
  '/data/collect/nist': 'GlobalOutlined',
  '/data/collect/docs': 'FileTextOutlined',
  '/data/base': 'AppstoreOutlined',
  '/data/base/dynamicPeriodic': 'PartitionOutlined',
  '/data/base/materialProperties': 'BuildOutlined',
  '/data/base/experimentResult': 'ExperimentOutlined',
  '/data/base/simulationData': 'FunctionOutlined',
  '/data/base/craftPerformance': 'BulbOutlined',
  '/data/base/docs': 'FileDoneOutlined',
  '/data/view': 'BarChartOutlined',
  '/data/view/dataFilter': 'FilterOutlined',
  '/data/view/chartGenerate': 'LineChartOutlined',
  '/data/view/dataExport': 'ExportOutlined',
  '/analysis': 'DashboardOutlined',
  '/analysis/statisticsAnalysis': 'DotChartOutlined',
  '/analysis/study': 'ExperimentOutlined',
  '/analysis/study/performancePrediction': 'SlidersOutlined',
  '/analysis/study/propertiesGrouper': 'ClusterOutlined',
  '/analysis/study/faultDetection': 'AlertOutlined',
  '/analysis/modeling': 'DeploymentUnitOutlined',
  '/analysis/modeling/modelConnect': 'ApiOutlined',
  '/analysis/model': 'ToolOutlined',
  '/analysis/model/modelTrain': 'PlayCircleOutlined',
  '/analysis/model/versionManager': 'BranchesOutlined',
  '/knowledge': 'ReadOutlined',
  '/knowledge/meterialGraph': 'BranchesOutlined',
  '/knowledge/recommend': 'LikeOutlined',
  '/knowledge/recommend/replaceRecommend': 'SwapOutlined',
  '/knowledge/recommend/performanceCandidate': 'AimOutlined',
  '/knowledge/cases': 'SolutionOutlined',
  '/knowledge/cases/digResult': 'SearchOutlined',
  '/knowledge/cases/projectExperience': 'ProfileOutlined',
  '/task': 'ScheduleOutlined',
  '/task/taskManager': 'OrderedListOutlined',
  '/task/dataFlow': 'ShareAltOutlined',
  '/task/experimentCalculate': 'ExperimentOutlined',
  '/tenant/home': 'HomeOutlined',
  '/tenant/device-monitor': 'MonitorOutlined',
  '/tenant/device-monitor/terminal-monitor': 'RadarChartOutlined',
  '/tenant/device-monitor/risk-monitor': 'AlertOutlined',
  '/tenant/device-monitor/meter-reading-list': 'UnorderedListOutlined',
  '/tenant/device-monitor/power-quality': 'AreaChartOutlined',
  '/tenant/device-monitor/history-data': 'HistoryOutlined',
  '/tenant/energy-stat': 'BarChartOutlined',
  '/tenant/energy-stat/history-energy': 'LineChartOutlined',
  '/tenant/energy-stat/area-energy': 'HeatMapOutlined',
  '/tenant/energy-stat/item-energy': 'PieChartOutlined',
  '/tenant/ops': 'ToolOutlined',
  '/tenant/ops/terminal-manage': 'TabletOutlined',
  '/tenant/ops/area-manage': 'DeploymentUnitOutlined',
  '/tenant/ops/quota-threshold': 'ControlOutlined',
  '/tenant/ops/alarm-center': 'BellOutlined',
  '/tenant/ops/work-order': 'FileTextOutlined',
  '/tenant/system': 'SettingOutlined',
  '/tenant/system/user-manage': 'TeamOutlined',
  '/tenant/system/role-permission': 'SafetyOutlined',
  '/tenant/system/operation-log': 'ProfileOutlined',
  '/system': 'SettingOutlined',
  '/system/usermanage': 'TeamOutlined',
  '/system/rolesmanage': 'SafetyOutlined',
  '/system/configurationManager': 'ControlOutlined',
  '/system/auditCompliance': 'AuditOutlined',
};

const nameIconDictionary = {
  首页: 'HomeOutlined',
  数据管理: 'DatabaseOutlined',
  '数据采集与导入': 'CloudUploadOutlined',
  '实验数据上传': 'UploadOutlined',
  '仿真计算结果导入': 'ImportOutlined',
  '外部数据库对接(MatWeb、NIST)': 'ApiOutlined',
  NIST数据库: 'GlobalOutlined',
  数据仓库: 'AppstoreOutlined',
  元素周期表: 'PartitionOutlined',
  材料基础属性库: 'BuildOutlined',
  物性实验结果库: 'ExperimentOutlined',
  仿真计算数据: 'FunctionOutlined',
  '工艺-性能关系数据': 'BulbOutlined',
  数据检索与可视化: 'BarChartOutlined',
  '条件筛选（成分、工艺、性能区间）': 'FilterOutlined',
  '图表生成（分布、相关性）': 'LineChartOutlined',
  导出功能: 'ExportOutlined',
  智能分析: 'DashboardOutlined',
  '统计分析（均值、方差、分布、相关性）': 'DotChartOutlined',
  机器学习模型: 'ExperimentOutlined',
  性能预测: 'SlidersOutlined',
  '属性分类/聚类': 'ClusterOutlined',
  异常检测: 'AlertOutlined',
  多尺度建模工具: 'DeploymentUnitOutlined',
  'DFT、MD、有限元模型对接': 'ApiOutlined',
  模型管理: 'ToolOutlined',
  '模型训练、测试、部署': 'PlayCircleOutlined',
  模型版本管理: 'BranchesOutlined',
  知识与推荐: 'ReadOutlined',
  '材料知识图谱（成分-工艺-性能关系）': 'BranchesOutlined',
  智能推荐: 'LikeOutlined',
  替代材料推荐: 'SwapOutlined',
  目标性能反推候选材料: 'AimOutlined',
  '知识库/案例库': 'SolutionOutlined',
  文献挖掘结果: 'SearchOutlined',
  历史项目经验: 'ProfileOutlined',
  任务与工作流: 'ScheduleOutlined',
  '分析任务管理（提交、监控、结果下载）': 'OrderedListOutlined',
  '数据处理流水线（ETL）': 'ShareAltOutlined',
  '实验-计算联合工作流': 'ExperimentOutlined',
  系统管理: 'SettingOutlined',
  系统用户: 'TeamOutlined',
  角色管理: 'SafetyOutlined',
  '配置管理（数据标准、元数据模板）': 'ControlOutlined',
  安全审计与合规: 'AuditOutlined',
};

const keywordIconPairs = [
  { keywords: ['首页', 'home'], icon: 'HomeOutlined' },
  { keywords: ['监测中心', '检测中心', '设备监控', 'device-monitor'], icon: 'MonitorOutlined' },
  { keywords: ['能耗统计', 'energy-stat'], icon: 'BarChartOutlined' },
  { keywords: ['运维中心', 'ops'], icon: 'ToolOutlined' },
  { keywords: ['数据', 'data'], icon: 'DatabaseOutlined' },
  { keywords: ['采集', '导入', '上传', 'import'], icon: 'CloudUploadOutlined' },
  { keywords: ['图', 'chart', '分析'], icon: 'BarChartOutlined' },
  { keywords: ['模型', 'model'], icon: 'ToolOutlined' },
  { keywords: ['任务', 'workflow'], icon: 'ScheduleOutlined' },
  { keywords: ['系统', '管理', '设置'], icon: 'SettingOutlined' },
  { keywords: ['知识', '推荐'], icon: 'ReadOutlined' },
  { keywords: ['实验', '仿真'], icon: 'ExperimentOutlined' },
];

const toPascalCase = (value) => {
  if (!value) {
    return '';
  }
  return value
    .replace(/[-_\s]+(.)?/g, (_, chr) => (chr ? chr.toUpperCase() : ''))
    .replace(/^\w/, (chr) => chr.toUpperCase());
};

const normalizeMenuIconInput = (value) => {
  if (!value) {
    return undefined;
  }
  if (React.isValidElement(value) || typeof value === 'object') {
    return value;
  }
  if (typeof value !== 'string') {
    return undefined;
  }
  return value.trim();
};

const resolveIconName = (item) => {
  const normalizedIcon = normalizeMenuIconInput(item.icon);
  if (normalizedIcon && typeof normalizedIcon !== 'string') {
    return normalizedIcon;
  }

  const iconCandidates = [];
  const iconString = typeof normalizedIcon === 'string' ? normalizedIcon : undefined;
  if (iconString) {
    iconCandidates.push(iconString);
  }

  if (item.path && pathIconDictionary[item.path]) {
    iconCandidates.push(pathIconDictionary[item.path]);
  }
  const nameKey = typeof item.name === 'string' ? item.name.trim() : '';
  if (nameKey && nameIconDictionary[nameKey]) {
    iconCandidates.push(nameIconDictionary[nameKey]);
  }

  if (nameKey) {
    const lowerName = nameKey.toLowerCase();
    keywordIconPairs.forEach(({ keywords, icon }) => {
      if (keywords.some((keyword) => lowerName.includes(keyword.toLowerCase()))) {
        iconCandidates.push(icon);
      }
    });
  }

  const uniqueCandidates = Array.from(new Set(iconCandidates.filter(Boolean)));
  for (const candidate of uniqueCandidates) {
    if (typeof candidate !== 'string') {
      return candidate;
    }
    const iconNode = createIconNode(candidate);
    if (iconNode) {
      return iconNode;
    }
  }
  return undefined;
};

const createIconNode = (icon) => {
  const candidates = [];
  const trimmed = icon.trim();
  if (!trimmed) {
    return undefined;
  }
  candidates.push(trimmed);
  const pascal = toPascalCase(trimmed);
  if (pascal && pascal !== trimmed) {
    candidates.push(pascal);
  }
  if (pascal && !pascal.endsWith('Outlined')) {
    candidates.push(`${pascal}Outlined`);
  }
  if (pascal && !pascal.endsWith('Filled')) {
    candidates.push(`${pascal}Filled`);
  }
  if (pascal && !pascal.endsWith('TwoTone')) {
    candidates.push(`${pascal}TwoTone`);
  }
  for (const name of candidates) {
    if (name && AntIcons[name]) {
      const IconComponent = AntIcons[name];
      return React.createElement(IconComponent);
    }
  }
  return undefined;
};

export const attachMenuIcon = (menus) => {
  if (!Array.isArray(menus)) {
    return menus;
  }
  return menus.map((item) => {
    const next = { ...item };

    const iconNode = resolveIconName(item);
    if (iconNode) {
      next.icon = iconNode;
    } else {
      delete next.icon;
    }
    if (Array.isArray(item.routes)) {
      next.routes = attachMenuIcon(item.routes);
    }
    if (Array.isArray(item.children)) {
      next.children = attachMenuIcon(item.children);
    }
    return next;
  });
};

export default attachMenuIcon;
